var $ = require('../modules/jquery');
var enquire = require('../modules/enquire');
var Swiper = require('../modules/swiper');

$(function() {

  var cardSwipes;

  // Functions
  // ---------------------------------------------------------------------------

  function initCardSwipes (e) {
    var bands = $('[data-card-swipe]');
    var containers = bands.find('.wrapper');
    var parts = bands.find('.band__part');

    // add swiper classes and pagination
    bands.addClass('swiper-container');
    containers.addClass('swiper-wrapper');
    parts.addClass('swiper-slide');
    bands.append('<div class="swiper-pagination"></div>');

    // remove unecessary markup
    containers.removeClass('wrapper');
    parts.unwrap();

    // initialize swiper
    cardSwipes = new Swiper(bands, {
      slidesPerView: 'auto',
      loop: false,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }

  function destroyCardSwipes (e) {
    var bands = $('[data-card-swipe]');
    var containers = bands.find('.swiper-wrapper');
    var parts = bands.find('.band__part');
    var pagination = $('.swiper-pagination');

    // destroy swipers
    $('.swiper-container').each(function () {
      this.swiper.destroy(true, true);
    });

    // reset default band classes
    containers.addClass('wrapper');
    containers.wrapInner('<div class="band__parts">');

    // remove swiper classes and pagination
    bands.removeClass('swiper-container');
    containers.removeClass('swiper-wrapper');
    parts.removeClass('swiper-slide');
    pagination.remove();
  }


  // Initializations
  // ---------------------------------------------------------------------------
  enquire.register('screen and (max-width: 639px)', {
    match: function () {
      initCardSwipes();
    },

    unmatch: function () {
      destroyCardSwipes(cardSwipes);
    }
  });

});



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/card-swipe.js
// module id = 13
// module chunks = 19